import { lato, nunito_sans } from '@styles/fonts'
import { makeStyles } from 'tss-react/mui'
import bg from 'src/assets/images/hub/notAlongBg.jpg'

const useStyles = makeStyles()((theme) => ({
  rootContainer: {
    borderRadius: '60px',
    backgroundImage: `url(${bg?.src})`,
    backgroundRepeat: 'repeat',
    padding: theme.spacing(20, 7),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(12, 6),
      borderRadius: '30px',
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(8, 4, 6),
    },
  },
  zenRootContainer: {
    background: 'none',
    border: '1px solid black',
  },
  textContainer: {
    maxWidth: '900px',
    margin: 'auto',
  },

  heading: {
    fontFamily: nunito_sans.style.fontFamily,
    fontSize: '72px',
    fontWeight: 800,
    lineHeight: ' 83px',
    textAlign: 'center',
    marginBottom: theme.spacing(3),
    textTransform: 'uppercase',
    [theme.breakpoints.down('md')]: {
      fontSize: '50px',
      lineHeight: '53.65px',
      marginBottom: theme.spacing(1),
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '32px',
      lineHeight: '43.65px',
      marginBottom: theme.spacing(1),
    },
  },
  text: {
    fontFamily: lato.style.fontFamily,
    fontSize: '20px',
    fontWeight: 400,
    lineHeight: ' 24px',
    textAlign: 'center',
    // marginBottom: theme.spacing(15),
    [theme.breakpoints.down('md')]: {
      fontSize: '18px',
      lineHeight: '20px',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
      lineHeight: '16.8px',
      // marginBottom: theme.spacing(10),
    },
  },
  btn: {
    margin: 'auto',
    background: 'black',
    color: 'white',
    textAlign: 'center',
    '&:hover': {
      background: 'white',
      color: 'black',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      flex: 1,
    },
  },
  btnWrapper: {
    width: 'fit-content !important',
    margin: 'auto',
    marginTop: theme.spacing(8),
    [theme.breakpoints.down('sm')]: {
      width: '100% !important',
    },
  },
}))

export default useStyles
